import { useEffect, useState } from 'react';

interface SafeAreaInsets {
  top: number;
  bottom: number;
}

export const useSafeAreaInsets = (): SafeAreaInsets => {
  const [insets, setInsets] = useState<SafeAreaInsets>({ top: 0, bottom: 0 });

  useEffect(() => {
    const updateInsets = () => {
      const rootStyles = getComputedStyle(document.documentElement);

      const top = parseInt(rootStyles.getPropertyValue('--safe-area-inset-top').trim(), 10) || 0;

      const bottom = parseInt(rootStyles.getPropertyValue('--safe-area-inset-bottom').trim(), 10) || 0;

      setInsets({ top, bottom });
    };

    updateInsets();

    window.addEventListener('resize', updateInsets);
    window.addEventListener('orientationchange', updateInsets);

    return () => {
      window.removeEventListener('resize', updateInsets);
      window.removeEventListener('orientationchange', updateInsets);
    };
  }, []);

  return insets;
};
